module.exports = __webpack_public_path__ + "static/media/operatorUserGuide.dab8c0bc.pdf";